export default {
  formId: 'checkoutForm',
  formField: {
    applicantNo: {
      name: 'applicantNo',
      label: 'เลขที่ใบสมัคร*',
      requiredErrorMsg: 'เลขที่ใบสมัคร is required',
    },
    position: {
      name: 'position',
      label: 'ตำแหน่ง*',
      requiredErrorMsg: 'ตำแหน่ง is required',
    },
    level: {
      name: 'level',
      label: 'ระดับ*',
      requiredErrorMsg: 'ระดับ is required',
    },
    positionCode: {
      name: 'positionCode',
      label: 'รหัสตำแหน่ง*',
      requiredErrorMsg: 'รหัสตำแหน่ง is required',
    },
    division: {
      name: 'division',
      label: 'ฝ่าย/สังกัด*',
      requiredErrorMsg: 'ฝ่าย/สังกัด is required',
    },
    duputy: {
      name: 'duputy',
      label: 'สายรอง*',
      requiredErrorMsg: 'สายรอง is required',
    },
    salutation: {
      name: 'salutation',
      label: 'คำนำหน้า*',
      requiredErrorMsg: 'คำนำหน้า is required',
    },
    rank: {
      name: 'rank',
      label: 'ยศ',
      // requiredErrorMsg: 'ยศ is required',
    },
    rankType: {
      name: 'rankType',
      label: 'ประเภทยศ',
      // requiredErrorMsg: 'คำนำหน้า is required',
    },
    firstName: {
      name: 'firstName',
      label: 'First name*',
      requiredErrorMsg: 'First name is required',
    },
    lastName: {
      name: 'lastName',
      label: 'Last name*',
      requiredErrorMsg: 'Last name is required',
    },
    nameEng: {
      name: 'nameEng',
      label: 'ชื่อ-นามสกุล ภาษาอังกฤษตัวพิมพ์ใหญ๋*',
      requiredErrorMsg: 'ชื่อ-นามสกุล ภาษาอังกฤษ is required',
    },
    nickName: {
      name: 'nickName',
      label: 'ชื่อเล่น/ชื่ออื่นๆ',
      requiredErrorMsg: 'ชื่อเล่น is required',
    },
    file1Name: {
      name: 'file1Name',
      label: 'เอกสารแนบ1',
      requiredErrorMsg: 'เอกสารแนบ1 is required',
    },
    file2Name: {
      name: 'file2Name',
      label: 'เอกสารแนบ2',
      requiredErrorMsg: 'เอกสารแนบ2 is required',
    },
    file3Name: {
      name: 'file3Name',
      label: 'เอกสารแนบ3',
      requiredErrorMsg: 'เอกสารแนบ3 is required',
    },
    address1: {
      name: 'address1',
      label: 'Address Line 1*',
      requiredErrorMsg: 'Address Line 1 is required',
    },
    address2: {
      name: 'address2',
      label: 'Address Line 2',
    },
    city: {
      name: 'city',
      label: 'City*',
      requiredErrorMsg: 'City is required',
    },
    state: {
      name: 'state',
      label: 'State/Province/Region',
    },
    zipcode: {
      name: 'zipcode',
      label: 'Zipcode*',
      requiredErrorMsg: 'Zipcode is required',
      invalidErrorMsg: 'Zipcode is not valid (e.g. 70000)',
    },
    country: {
      name: 'country',
      label: 'Country*',
      requiredErrorMsg: 'Country is required',
    },
    useAddressForPaymentDetails: {
      name: 'useAddressForPaymentDetails',
      label: 'Use this address for payment details',
    },
    nameOnCard: {
      name: 'nameOnCard',
      label: 'Education 1*',
      requiredErrorMsg: 'Education 1 is required',
    },
    cardNumber: {
      name: 'cardNumber',
      label: 'Education 2*',
      requiredErrorMsg: 'Education 2 is required',
      invalidErrorMsg: 'Education 2 is not valid (e.g. 4111111111111)',
    },
    cvv: {
      name: 'cvv',
      label: 'CVV*',
      requiredErrorMsg: 'CVV is required',
      invalidErrorMsg: 'CVV is invalid (e.g. 357)',
    },
    eduPeriod: {
      name: 'eduPeriod',
      label: 'ระยะเวลา (ปี)',
      requiredErrorMsg: 'ระยะเวลา is required',
    },
    eduYearFrom: {
      name: 'eduYearFrom',
      label: 'จาก',
      requiredErrorMsg: 'ระยะเวลาจาก... is required',
    },
    eduYearTo: {
      name: 'eduYearTo',
      label: 'ถึง',
      requiredErrorMsg: 'ระยะเวลาถึง... is required',
    },
    // educations: [
    //   {
    //     eduPeriod: {
    //       name: 'eduPeriod',
    //       label: 'ระยะเวลา (ปี)',
    //       requiredErrorMsg: 'ระยะเวลา is required',
    //     },
    //     eduYearFrom: {
    //       name: 'eduYearFrom',
    //       label: 'จาก',
    //       requiredErrorMsg: 'ระยะเวลาจาก... is required',
    //     },
    //     eduYearTo: {
    //       name: 'eduYearTo',
    //       label: 'ถึง',
    //       requiredErrorMsg: 'ระยะเวลาถึง... is required',
    //     },
    //   },
    // ],
    originalName: {
      name: 'originalName',
      label: 'ชื่อตัวเดิม (ถ้ามี)',
      requiredErrorMsg: 'ชื่อตัวเดิม is required',
    },
    originalSurname: {
      name: 'originalSurname',
      label: 'ชื่อสกุลเดิม (ถ้ามี)',
      requiredErrorMsg: 'ชื่อสกุลเดิม is required',
    },
    idCard: {
      name: 'idCard',
      label: 'เลขประจำตัวประชาชน',
      requiredErrorMsg: 'เลขประจำตัวประชาชน is required',
    },
    birthdate: {
      name: 'birthdate',
      label: 'วัน/เดือน/ปีเกิด',
      requiredErrorMsg: 'วัน/เดือน/ปีเกิด is required',
    },
    registBirthPlace: {
      name: 'registBirthPlace',
      label: 'สถานที่จดทะเบียนเกิด',
      requiredErrorMsg: 'สถานที่จดทะเบียนเกิด is required',
    },
    placeOfBirth: {
      name: 'placeOfBirth',
      label: 'ภูมิลำเนา',
      requiredErrorMsg: 'ภูมิลำเนา is required',
    },
    empWeight: {
      name: 'empWeight',
      label: 'น้ำหนัก',
      requiredErrorMsg: 'น้ำหนัก is required',
    },
    empHeight: {
      name: 'empHeight',
      label: 'ส่วนสูง',
      requiredErrorMsg: 'ส่วนสูง is required',
    },
    bloodType: {
      name: 'bloodType',
      label: 'หมู่โลหิต',
      requiredErrorMsg: 'หมู่โลหิต is required',
    },
    empWound: {
      name: 'empWound',
      label: 'ตำหนิ',
      requiredErrorMsg: 'ตำหนิ is required',
    },
    empWound: {
      name: 'empWound',
      label: 'ตำหนิ',
      requiredErrorMsg: 'ตำหนิ is required',
    },
    empOrigin: {
      name: 'empOrigin',
      label: 'เชื่อชาติ',
      requiredErrorMsg: 'เชื่อชาติ is required',
    },
    empNationality: {
      name: 'empNationality',
      label: 'สัญชาติ',
      requiredErrorMsg: 'สัญชาติ is required',
    },
    empReligion: {
      name: 'empReligion',
      label: 'ศาสนา',
      requiredErrorMsg: 'ศาสนา is required',
    },
    empOriginalNationality: {
      name: 'empOriginalNationality',
      label: 'สัญชาติเดิม',
      requiredErrorMsg: 'สัญชาติเดิม is required',
    },
    isForeigner: {
      name: 'isForeigner',
      label: 'กรณีเป็นต่างด้าว',
      requiredErrorMsg: 'กรณีเป็นต่างด้าว is required',
    },
    medicalCondition: {
      name: 'medicalCondition',
      label: 'โรคประจำตัว',
      requiredErrorMsg: 'โรคประจำตัว is required',
    },
    addressPass15yr: {
      name: 'addressPass15yr',
      label: 'ระยะเวลา (ปี)',
      requiredErrorMsg: 'ระยะเวลา is required',
    },
    addressPass15yrFrom: {
      name: 'addressPass15yrFrom',
      label: 'จาก',
      requiredErrorMsg: 'ระยะเวลาจาก... is required',
    },
    addressPass15yrTo: {
      name: 'addressPass15yrTo',
      label: 'ถึง',
      requiredErrorMsg: 'ระยะเวลาถึง... is required',
    },
    addressPass15yrAddressNumber: {
      name: 'addressPass15yrAddressNumber',
      label: 'บ้านเลขที่',
      requiredErrorMsg: 'บ้านเลขที่ is required',
    },
    addressPass15yrAddressTambol: {
      name: 'addressPass15yrAddressTambol',
      label: 'แขวง/ตำบล',
      requiredErrorMsg: 'แขวง/ตำบล is required',
    },
    addressPass15yrAddressDistrict: {
      name: 'addressPass15yrAddressDistrict',
      label: 'อำเภอ/เขต',
      requiredErrorMsg: 'อำเภอ/เขต is required',
    },
    addressPass15yrAddressProvince: {
      name: 'addressPass15yrAddressProvince',
      label: 'จังหวัด',
      requiredErrorMsg: 'จังหวัด is required',
    },
    addressPass15yrAddressPost: {
      name: 'addressPass15yrAddressPost',
      label: 'รหัสไปรษณีย์',
      requiredErrorMsg: 'รหัสไปรษณีย์ is required',
    },
    addressPass15yrAddressCountry: {
      name: 'addressPass15yrAddressCountry',
      label: 'ประเทศ',
      requiredErrorMsg: 'ประเทศ is required',
    },
    acceptConsent: {
      name: 'AcceptConsent',
      label: 'เอกสารการให้ความยินยอมสำหรับผู้สมัครงาน',
      requiredErrorMsg: 'เอกสารการให้ความยินยอมสำหรับผู้สมัครงาน is required',
    },
  }
};
